<template>
  <van-dialog
    v-model="showModal"
    title="选择关联的传感器"
    class="cgq_modal"
    show-cancel-button
    @confirm="modalConfirm"
    @close="close"
  >
    <template slot="default">
      <div class="tags">
        <div
          class="tag"
          v-for="(item, index) in list"
          :key="item.id"
          :class="item.check && 'active'"
          @click="handleTagClick(item, index)"
        >
          {{ item.aliasName }}
        </div>
      </div>
    </template>
  </van-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    cancel: {
      type: Function,
      default: () => {}
    },
    confirm: {
      type: Function,
      default: () => {}
    }
  },

  watch: {
    show(v) {
      console.log("v:", v);
      this.showModal = v;
    }
  },

  data() {
    return {
      list: [],
      showModal: false
    };
  },

  async mounted() {
    this.$toast({
      type: "loading",
      message: "阀门加载中...",
      forbidClick: true,
      duration: 0
    });

    await this.$api
      .getCgqData({
        gatewayNo: localStorage.getItem("no")
      })
      .then(res => {
        if (res.errcode === 0 && res.data && res.data.length) {
          this.list = res.data.map(item => {
            return { ...item, check: false };
          });
        } else {
          this.list = [];
        }
      });

    this.$toast.clear();
  },

  methods: {
    handleTagClick(data, ind) {
      this.list.map((item, index) => {
        if (ind === index) {
          item.check = !item.check;
        } else {
          item.check = false;
        }
      });
    },

    modalConfirm() {
      this.$emit(
        "confirm",
        this.list.filter(o => o.check)
      );
    },

    close() {
      this.$emit("cancel", false);
    }
  }
};
</script>

<style lang="scss" scoped>
.cgq_modal {
  width: 80% !important;
  border-radius: 0 !important;
}

/deep/.van-dialog__content {
  padding: 10px;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .tag {
    border: 1px solid #999;
    padding: 4px 8px;
    border-radius: 4px;
    margin-bottom: 10px;
  }

  .active {
    background: #4776ea;
    border-color: #4776ea;
    color: #ffffff;
  }

  &:after {
    content: "";
    flex: auto;
  }
}
</style>
